var React = require('react');

function FrameInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Subtraction_37","data-name":"Subtraction 37","d":"M554,603H50V447.23L301.908,592.677,553.874,447.2V156.236L301.908,10.756,50,156.2V0H554V603Z","transform":"translate(-50)","fill":"#fff"}));
}

FrameInline.defaultProps = {"width":"504","height":"603.001","viewBox":"0 0 504 603.001","style":{"transform":"scale(1.01)"}};

module.exports = FrameInline;

FrameInline.default = FrameInline;
